'use client';

import { createContext, useContext, useMemo } from 'react';

import { useAccordionContext } from '../contexts/accordion-context';

interface AccordionItemContextType {
	value: string;
	expanded: boolean;
};

const AccordionItemContext = createContext<AccordionItemContextType>({
	value: '',
	expanded: false
});

export function AccordionItemProvider({ 
	value,
	isSelected,
	children
}: { 
	value: string;
	isSelected?: boolean;
	children: React.ReactNode;
}) {
	const { activeValue } = useAccordionContext();
	const expanded = isSelected ? isSelected : (activeValue === value);

	const contextValue = useMemo(() => ({ 
		value,
		expanded,
	}), [value, expanded]);

	return (
		<AccordionItemContext.Provider value={contextValue}>
			{children}
		</AccordionItemContext.Provider>
	);
}

export const useAccordionItemContext = () => useContext(AccordionItemContext);